<evc-nav-button type="cta" size="xxl" variant="round" (click)="addAssetType()" *callToAction [disabled]="createAssetTypeDisabled()">
  <span class="top-cta-label">
    {{ "assetBuilder.createAssetType" | translate }}
  </span>
  <evc-svg-icon size="md" [icon]="'plus'"></evc-svg-icon>
</evc-nav-button>

<asset-types></asset-types>
